// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1XUKj","info":"PatientInfo_info__19E1X"};